// ========================================
// ================== V3 ==================
// ========================================

import { updateObject } from "../../helpers/index";
import * as aTypes from "../actions/actionTypes";

const initialState = {
  bestplays: null,
  bestplays_error: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case aTypes.V3_BESTPLAYS_SET:
      return fetchBestplaysSet(state, action);
    case aTypes.V3_BESTPLAYS_FETCH_FAIL:
      return fetchBestplaysSetFail(state, action);
    default:
      return state;
  }
};

const fetchBestplaysSet = (state, action) => {
  return updateObject(state, {
    bestplays: action.bestplays,
  });
};

const fetchBestplaysSetFail = (state, action) => {
  return updateObject(state, {
    bestplays_error: action.error,
  });
};

export default reducer;
